<template>
  <div class="vue_flex vue_column">
    <div class="cont_wrapper">
      <div class="cont_wrapper_sx">
        <div class="shaixuan_left">
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
              <div class="shaixuan_item_tit">统计时间</div>
            </div>
            <el-date-picker v-model="listQuery.time" type="datetimerange" range-separator="" start-placeholder=""
              end-placeholder="" value-format="timestamp" class="vue_flex_item" placeholder="选择日期">
            </el-date-picker>
          </div>
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
              <div class="shaixuan_item_tit">渠道</div>
            </div>
            <el-select v-model="listQuery.type" placeholder="请选择" class="vue_flex_item">
              <el-option v-for="item in qudaooptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img class="shaixuan_item_icon" src="../../../../../assets/ym/dp@2x.png" alt="" />
              <div class="shaixuan_item_tit">店铺</div>
            </div>
            <el-select v-model="listQuery.shopid" placeholder="请选择" class="vue_flex_item">
              <el-option v-for="item in dpList" :key="item.shopid" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>

          <div class="shaixuan_item h">
            <div class="shaixuan_item_con">
              <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
              <div class="shaixuan_item_tit" style="width: 40px">商品</div>
            </div>
            <el-input v-model="listQuery.goodsid" placeholder="请输入商品id"></el-input>
          </div>
        </div>

        <div class="shaixuan_btns">
          <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
          <div class="shaixuan_btn2 h" @click="search">查询</div>
        </div>
      </div>
      <div class="home_title">
        <div class="vue_flex">
          <div class="home_tit vue_relative h" :class="tabs.id === tabsId ? 'home_tit_active' : 'home_tit_activenot'
            " v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="tabsClick(tabs)">
            <p>{{ tabs.title }}</p>
            <div class="home_solid vue_absolute" v-if="tabs.id === tabsId"></div>
          </div>
        </div>
        <!-- <div class="home_right">
          <div class="home_right_1">
            <div>日</div>
            <img src="../../../../../assets/ym/xl@2x.png" alt="" />
          </div>
          <img
            class="home_right_2"
            src="../../../../../assets/ym/gd@2x.png"
            alt=""
          />
        </div> -->
      </div>
      <div style="margin-top: 25px" class="vue-font-PingFang-500 color_35 font22 line_height_22">
        经营报表-核心指标趋势图
      </div>

      <linkwhole :list="linkList" @itemClick="linkboxsClick"></linkwhole>

      <div id="myChart"></div>

      <div class="home_title">
        <div class="home_tit">
          经营报表-渠道-{{ tabsId === 1 ? "支付" : "发货" }}
        </div>
      </div>

      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }">
        <el-table-column prop="goodsid" label="商品ID" align="center"></el-table-column>
        <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="maolirun" :label="tabsId == 1 ? '毛利（支付）' : '毛利（发货）'" align="center"></el-table-column>
        <el-table-column prop="maolilv" :label="tabsId == 1 ? '毛利率 %（支付）' : '毛利率 %（发货）'" align="center">
          <template slot-scope="scope">
            {{ scope.row.maolilv + '%' }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="jinlirun"
          :label="tabsId == 1 ? '净利润（支付）' : '净利润（发货）'"
          align="center"
        ></el-table-column>
        <el-table-column prop="jinlirunlv" :label="tabsId == 1 ? '净利润率 %（支付）' : '净利润率 %（发货）'" align="center" >
          <template slot-scope="scope">
            {{scope.row.jinlirunlv + '%'}}
          </template>
        </el-table-column> -->
        <el-table-column prop="yewulirun" label="业务利润（支付）" align="center"></el-table-column>
        <el-table-column prop="yewulirunlv" label="业务利润率 %（支付）" align="center"></el-table-column>
        <el-table-column prop="xiaoshoushouru" label="销售收入" align="center"></el-table-column>
        <el-table-column prop="xiaoshounum" label="销售数量" align="center"></el-table-column>
        <el-table-column prop="shouhoushuliang" label="售后数量" align="center"></el-table-column>
        <el-table-column prop="shouhoumoney" label="售后金额" align="center"></el-table-column>
        <el-table-column prop="xiaoshoushouru" label="销售收入去退（支付）" align="center"></el-table-column>
        <el-table-column prop="tuikuailv" label="退款率 %（支付）" align="center"></el-table-column>
        <el-table-column prop="fahuoqiantuikuanjine" label="发货前退款金额" align="center"></el-table-column>
        <el-table-column prop="fahuobegintuikuanlv" label="发货前退款率 %（支付）" align="center"></el-table-column>
        <el-table-column prop="fahuohoutuikuanjine" label="发货后退款金额" align="center"></el-table-column>
        <el-table-column prop="fahuoendtuikuanlv" label="发货后退款率 %（支付）" align="center"></el-table-column>
        <el-table-column prop="yewuchengben" label="业务成本（利润）" align="center"></el-table-column>
        <el-table-column prop="xianshangguanggaotoufangfeiyong" label="线上广告投放费用" align="center"></el-table-column>
        <el-table-column prop="guanggaobi" label="广告投放费比" align="center"></el-table-column>
        <el-table-column prop="pingtaigudingkoudian" label="平台固定扣点" align="center"></el-table-column>
        <el-table-column prop="pingtaiqitakoukuan" label="平台其它扣款" align="center"></el-table-column>
        <el-table-column prop="pingtaiyingxiaohuodong" label="平台营销活动" align="center"></el-table-column>
        <el-table-column prop="teshudanfeiyong" label="特殊单费用" align="center"></el-table-column>
        <el-table-column prop="baozhuangfeiyong" label="包装费用" align="center"></el-table-column>
        <el-table-column prop="kuaidifeiyong" label="快递费用" align="center"></el-table-column>
        <el-table-column prop="zengpinfeiyong" label="赠品费用" align="center"></el-table-column>
        <el-table-column prop="paishefeiyong" label="拍摄费用" align="center"></el-table-column>
        <el-table-column prop="cangchufeiyong" label="仓储费用" align="center"></el-table-column>
        <el-table-column prop="guanlifeiyong" label="管理费用" align="center"></el-table-column>
        <el-table-column prop="kaifafeiyong" label="开发费用" align="center"></el-table-column>
        <el-table-column prop="rengongzhichu" label="人工支出" align="center"></el-table-column>
        <el-table-column prop="shuijinfujia" label="税金附加" align="center"></el-table-column>
        <el-table-column prop="yunfeifeibi" label="运费费比" align="center">
             <template slot-scope="scope">
            {{ scope.row.xiaoshoushouru == 0?'0%':Math.floor(Number(scope.row.kuaidifeiyong)/Number(scope.row.xiaoshoushouru)*10000)/100 + '%' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                @pagination="getDataList" />
  </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkwhole from "@/components/linkwhole/index";
import DonMessage from "@/utils/message";
export default {
  components: { Pagination, linkwhole },
  data() {
    return {
      dpList: [],
      qudaooptions: [
        { value: "1", label: "淘宝" },
        { value: "2", label: "京东" },
        { value: "3", label: "拼多多" },
      ],
      total: 0,
      listQuery: {
        time: [],
        type: "",
        shopid: "",
        goodsid: "",
        page:1,
        limit:10
      },

      tabsId: 1,
      tabsList: [
        { id: 1, title: "支付口径" },
        { id: 2, title: "发货口径" },
      ],

      charts: "",
      opinionData: ["3", "2", "4", "4", "5"],
      // linkList: [
      //   {
      //     tit: "业务利润（支付）",
      //     num: "",
      //     bi: "业务利润率（支付）",
      //     img: require("../../../../../assets/ym/ywlrl.png"),
      //     height: 181,
      //     width: 367,
      //   },
      //   {
      //     tit: "销售收入",
      //     num: "",
      //     bi: "销售数量       ",
      //     bihou: "销售订单数    ",
      //     img: require("../../../../../assets/ym/xssr.png"),
      //     height: 181,
      //     width: 367,
      //   },
      //   {
      //     tit: "销售金额",
      //     num: "",
      //     bi: "售后数量  ",
      //     img: require("../../../../../assets/ym/gtkl@2x.png"),
      //     height: 181,
      //     width: 367,
      //   },
      //   {
      //     tit: "业务成本（利润）",
      //     num: "",
      //     img: require("../../../../../assets/ym/ywcb.png"),
      //     height: 181,
      //     width: 367,
      //   },
      //   {
      //     tit: "费用",
      //     num: "",
      //     img: require("../../../../../assets/ym/fy.png"),
      //     height: 181,
      //     width: 367,
      //   },
      //   {
      //     tit: "退款率（支付）",
      //     num: "",
      //     bi: "销售数量       ",
      //     bihou: "销售订单数    ",
      //     img: require("../../../../../assets/ym/tkl.png"),
      //     height: 181,
      //     width: 367,
      //   },
      // ],
      linkList: [
        {
          tit: "业务利润",
          num: "",
          img: require("../../../../../assets/ym/ywlrl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "业务利润率",
          num: "",
          img: require("../../../../../assets/ym/ywlrl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "销售收入",
          num: "",
          img: require("../../../../../assets/ym/xssr.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "销售数量",
          num: "",
          img: require("../../../../../assets/ym/xssr.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "售后金额",
          num: "",
          img: require("../../../../../assets/ym/xssr.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "售后数量",
          num: "",
          img: require("../../../../../assets/ym/gtkl@2x.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "退款率",
          num: "",
          img: require("../../../../../assets/ym/ywcb.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "发货前退款率",
          num: "",
          img: require("../../../../../assets/ym/fy.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "发货后退款率",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        // {
        //   tit: "销售收入去退",
        //   num: "",
        //   img: require("../../../../../assets/ym/tkl.png"),
        //   height: 181,
        //   width: 367,
        // },
        {
          tit: "业务成本（利润）",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "毛利润",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "毛利率",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "线上广告投放费用",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "广告投放费比",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "净利润",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
        {
          tit: "净利润率",
          num: "",
          img: require("../../../../../assets/ym/tkl.png"),
          height: 181,
          width: 367,
        },
      ],

      userObj: {},
      tableData: [],

      value1: "",
    };
  },
  mounted() {
    this.getList();
    this.gettb();
    this.getDataList();
    this.getdpListFun();
    this.$nextTick(function () {
      this.drawLine("myChart");
    });
  },

  methods: {
    linkboxsClick(msg) {
      console.log('msg--->', msg);
      this.$nextTick(function () {
        this.drawLine("myChart", msg.tubiao);
      });
    },
    search() {
      this.getList();
      this.gettb();
      this.tableData = [];
      this.getDataList();
    },
    qingchu() {
      this.listQuery = {
        time: [],
        type: "",
        shopid: "",
        goodsid: "",
        page:1,
        limit:10
      };
      this.getList();
    },
    // 店铺列表
    async getdpListFun() {
      const res = await this.$http.get(this.$urls.getshoplist, {
        page: 1,
        limit: 10000,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dpList = res.list;
    },
    async getDataList() {
      let params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        leixing: this.tabsId == 1 ? "zhichu" : "fahuo",
        starttime:
          this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
        endtime:
          this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
        goodsid: this.listQuery.goodsid,
        iscaiwu: 1
      };
      console.log('00000000000000')
      const res = await this.$http.get(this.$urls.lirunribao_goods, params);
      console.log(res, '11111111111111111111111')
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.tableData = res.allData;
      this.total = res.count
    },
    async gettb() {
      let url = this.$urls.lirunribao_zhifu_echart;
      if (this.tabsId != 1) {
        url = this.$urls.lirunribao_fahuo_echart;
      }
      const res = await this.$http.get(url, {
        type: this.listQuery.type,
        iscaiwu: 1,
        shopid: this.listQuery.shopid,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      for (let key of this.linkList) {
        if (key.tit == "业务利润") {
          key.tubiao = res.yewulirunEcharts;
        }
        if (key.tit == "业务利润率") {
          key.tubiao = res.yewulirunlvEcharts;
        }
        if (key.tit == "销售收入") {
          key.tubiao = res.xiaoshoushouruEcharts;
        }
        if (key.tit == "销售数量") {
          key.tubiao = res.xiaoshounumEcharts;
        }
        if (key.tit == "售后金额") {
          key.tubiao = res.shouhoumoneyEcharts;
        }
        if (key.tit == "售后数量") {
          key.tubiao = res.shouhoushuliangEcharts;
        }
        if (key.tit == "退款率") {
          key.tubiao = res.tuikuailvEcharts;
        }
        if (key.tit == "发货前退款率") {
          key.tubiao = res.fahuobegintuikuanlvEcharts;
        }
        if (key.tit == "发货后退款率") {
          key.tubiao = res.fahuoendtuikuanlvEcharts;
        }
        if (key.tit == "销售收入去退") {
          key.tubiao = res.xiaoshoushouruEcharts;
        }
        if (key.tit == "业务成本（利润）") {
          key.tubiao = res.yewuchengbenEcharts;
        }
        if (key.tit == "毛利润") {
          key.tubiao = res.maolirunEcharts;
        }
        if (key.tit == "毛利率") {
          key.tubiao = res.maolilvEcharts;
        }
        if (key.tit == "线上广告投放费用") {
          key.tubiao = res.tuiguangmoneyEcharts;
        }
        if (key.tit == "广告投放费比") {
          key.tubiao = res.guanggaobiEcharts;
        }
        if (key.tit == "净利润") {
          key.tubiao = res.jinlirunEcharts;
        }
        if (key.tit == "净利润率") {
          key.tubiao = res.jinlirunlvEcharts;
        }
      }
      this.$nextTick(function () {
        this.drawLine("myChart", res.yewulirunEcharts);
      });
    },
    async getList() {
      let params = {
        type: this.listQuery.type,
        shopid: this.listQuery.shopid,
        starttime:
          this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
        endtime:
          this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
        goodsid: this.listQuery.goodsid,
        iscaiwu: 1
      };
      let url = this.$urls.lirunribao_zhifu;
      if (this.tabsId != 1) {
        url = this.$urls.lirunribao_fahuo;
      }
      const res = await this.$http.post(url, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      for (let key of this.linkList) {
        if (key.tit == "业务利润") {
          key.num = res.yewulirun;
        }
        if (key.tit == "业务利润率") {
          key.num = res.yewulirunlv + '%';
        }
        if (key.tit == "销售收入") {
          key.num = res.xiaoshoushouru;
        }
        if (key.tit == "销售数量") {
          key.num = res.xiaoshounum;
        }
        if (key.tit == "售后金额") {
          key.num = res.shouhoumoney;
        }
        if (key.tit == "售后数量") {
          key.num = res.shouhoushuliang;
        }

        if (key.tit == "退款率") {
          key.num = res.tuikuailv + '%';
        }
        if (key.tit == "发货前退款率") {
          key.num = res.fahuobegintuikuanlv + '%';
        }
        if (key.tit == "发货后退款率") {
          key.num = res.fahuoendtuikuanlv + '%';
        }
        if (key.tit == "销售收入去退") {
          key.num = res.xiaoshoushouru || 0;
        }
        if (key.tit == "业务成本（利润）") {
          key.num = res.yewuchengben || 0;
        }
        if (key.tit == "毛利润") {
          key.num = res.maolirun;
        }
        if (key.tit == "毛利率") {
          key.num = res.maolilv + '%';
        }
        if (key.tit == "线上广告投放费用") {
          key.num = res.tuiguangmoney;
        }
        if (key.tit == "广告投放费比") {
          key.num = res.guanggaobi + '%';
        }
        if (key.tit == "净利润") {
          key.num = res.jinlirun;
        }
        if (key.tit == "净利润率") {
          key.num = res.jinlirunlv + '%';
        }
      }

    },
    drawLine(id, item) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [""],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: item.x,
        },
        yAxis: {
          type: "value",
        },

        series: [
          {
            name: "近七日",
            type: "line",
            stack: "总量",
            data: item.y,
          },
        ],
      });
    },

    getHetongListFun() { },

    tabsClick(row) {
      if (this.tabsId === row.id) return;
      this.tabsId = row.id;
      this.getList();
      this.gettb();
      this.getDataList();
    },
  },
};
</script>

<style lang="scss" scoped>
#myChart {
  margin-top: 30px;
  width: 1508px;
  height: 300px;
}

.home_title {
  width: 100%;
  height: 55px;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .home_tit {
    p {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 26px;
      margin-right: 47px;
    }

    .home_solid {
      width: 34px;
      height: 3px;
      background: #195cf8;
      border-radius: 2px;
      bottom: -12px;
      left: 50%;
      margin-left: -38px;
    }
  }

  .home_tit_active {
    color: rgba(25, 92, 248, 1);
  }

  .home_tit_activenot {
    color: rgba(35, 35, 35, 1);
  }

  .home_right {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .home_right_2 {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      margin-left: 10px;
    }

    .home_right_1 {
      padding: 0 10px;
      width: 108px;
      height: 45px;
      background: #f4f5f9;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
  }
}

.shaixuan_btns {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;

  .shaixuan_btn1 {
    width: 132px;
    height: 55px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #999999;
    text-align: center;
    line-height: 55px;
  }

  .shaixuan_btn2 {
    margin-left: 25px;
    width: 131px;
    height: 54px;
    background: #195cf8;
    border-radius: 10px;
    text-align: center;
    line-height: 55px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
  }
}

.cont_wrapper {
  padding: 25px;

  .cont_wrapper_sx {
    width: 1527px;
    height: 71px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .shaixuan_left {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
    }

    .shaixuan_item {
      width: 280px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      margin-right: 22px;

      .shaixuan_item_con {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        .shaixuan_item_tit {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #232323;
        }

        .shaixuan_item_sel {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
        }

        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }

        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
}

.shaixuan_item {
  /deep/ .el-date-editor {
    border: none !important;
    text-align: right;
    font-size: 18px;
    width: 196px;
  }

  /deep/ .el-input__icon {
    display: none;
  }

  .el-input /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }

  .el-input /deep/.el-input__prefix {
    display: none !important;
  }

  .el-select /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/dashboard/encoding/index.vue